import { FC } from 'react';

import classNames from 'classnames';
import { CampaignProductType } from 'utils/constants/campaign';

import VSpacing from '@hh.ru/bloko/build/blocks/vSpacing';

import AuctionSettings from 'components/CampaignCard/AuctionSettings';
import BannersTabs from 'components/CampaignCard/BannersTabs/BannersTabs';
import CampaignInfo from 'components/CampaignCard/CampaignInfo/CampaignInfo';
import CampaignTitle from 'components/CampaignCard/CampaignTitle/CampaignTitle';
import CampaignSettings from 'components/CampaignCard/Settings/Settings';

import { Campaign, CampaignTabStatus } from 'store/models/dashboard';
import { useSelector } from 'store/utils';

import styles from 'components/CampaignCard/CampaignCard.module.less';

interface CampaignCardProps {
    campaign: Campaign;
    maxBannersInCampaign: number;
    realBalance: number;
    userBalance: number;
}

const CampaignCard: FC<CampaignCardProps> = ({ campaign, maxBannersInCampaign, realBalance, userBalance }) => {
    const campaignTabsStatus = useSelector((state) => state.campaignTabsStatus);
    const isActiveTabsStatus = campaignTabsStatus === CampaignTabStatus.Active;

    const {
        allBanners,
        archiveReason,
        countBanners,
        frontendStatus,
        id: campaignId,
        name,
        productType,
        vacancyId,
        advertisingServiceType,
    } = campaign;

    const isAuction = productType === CampaignProductType.SearchAuction;

    return (
        <div className={styles.campaignCard} data-qa={`campaign-block__${name}`}>
            <div
                className={classNames(styles.campaignContent, !isActiveTabsStatus && styles.campaignContentArchivedTab)}
            >
                <CampaignTitle campaignId={campaignId} name={name} isAuction={isAuction} />
                <div className={isActiveTabsStatus ? styles.campaignContentPadding : ''}>
                    <VSpacing base={2} />
                    <CampaignInfo
                        campaign={campaign}
                        userBalance={userBalance}
                        realBalance={realBalance}
                        isAuction={isAuction}
                    />
                    {isAuction ? (
                        <AuctionSettings
                            archiveReason={archiveReason}
                            frontendStatus={frontendStatus}
                            vacancyId={vacancyId}
                        />
                    ) : (
                        <CampaignSettings
                            banners={allBanners}
                            campaignId={campaignId}
                            countBanners={countBanners}
                            maxBannersInCampaign={maxBannersInCampaign}
                            frontendStatus={frontendStatus}
                            archiveReason={archiveReason}
                        />
                    )}
                </div>
            </div>
            {!isAuction && (
                <BannersTabs
                    campaignId={campaignId}
                    countBanners={countBanners}
                    banners={allBanners}
                    campaignStatus={frontendStatus}
                    vacancyId={vacancyId}
                    advertisingServiceType={advertisingServiceType}
                />
            )}
        </div>
    );
};

export default CampaignCard;
